var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChilis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.154,
    height: 24.357,
    viewBox: "0 0 48.154 24.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20217",
    "data-name": "Grupo 20217",
    transform: "translate(21786.157 -1638.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27635",
    "data-name": "Trazado 27635",
    d: "M69.164,71.132c-1.27-1.2-1.673-.975-2.51-3.494-.4-1.221-1.152-2.7-2.4-3.13-2.2-.738-4.489.906-5.995,2.362-1.6,1.545-2.284,3.337-6.428,6.113A10.722,10.722,0,0,1,47.9,74.547c-1.713.315-3.17-.2-4.843-.335-3.2-.276-5.68.945-5.69,2.855S42.243,82.255,46.347,83c5.247.945,9.46.689,12.255-.167a22.341,22.341,0,0,0,10.178-5.827c1.555-1.565,2.431-3.957.394-5.886",
    transform: "translate(-21823.527 1579.434)",
    fill: "#cf3a2b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27636",
    "data-name": "Trazado 27636",
    d: "M71.2,64.557a2.063,2.063,0,0,0-.423-1.4,2.846,2.846,0,0,1-.787-2.057,2,2,0,0,1,2.3-1.762c1.349.148,2.52,1.309,2.284,3.5-.354,3.337-3.593,5.827-4.7,5.719a.771.771,0,0,1-.689-.866,1.05,1.05,0,0,1,.433-.738A4.4,4.4,0,0,0,71.2,64.577",
    transform: "translate(-21824.023 1579.513)",
    fill: "#6c8a32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27637",
    "data-name": "Trazado 27637",
    d: "M79.5,74.37l-1.486-.689c-1.043-.443-2.353-1.014-2.353-2.5a1.764,1.764,0,0,1,1.792-1.792,2.234,2.234,0,0,1,2.028,1.457c.335.561.719,1.221,1.644,1.221a1.4,1.4,0,0,0,1.427-1.457c0-1.191-1.339-3.189-4.941-3.189s-5.188,2.264-5.188,4.38c0,2.776,2.392,3.937,3.288,4.351a21.232,21.232,0,0,1,2.963,1.536,2.2,2.2,0,0,1,.965,1.831,1.8,1.8,0,0,1-1.88,1.851c-1.191,0-1.732-.768-2.441-1.792-.413-.561-.837-1.162-1.673-1.162a1.556,1.556,0,0,0-1.516,1.6c0,1.191,1.427,3.613,5.542,3.613,4.449,0,5.375-3.012,5.375-4.686,0-2.864-2.146-3.928-3.524-4.587",
    transform: "translate(-21824.07 1579.386)",
    fill: "#6c8a32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27638",
    "data-name": "Trazado 27638",
    d: "M86.249,82.72a1.238,1.238,0,1,0,0,.01m-2.274.059a.973.973,0,0,0,1,.984,1,1,0,0,0-.059-2.008.977.977,0,0,0-.945,1.024m.787.63h-.285l-.039-1.25a2.7,2.7,0,0,1,.482-.049.784.784,0,0,1,.443.089.338.338,0,0,1,.138.266.323.323,0,0,1-.256.305h0a.426.426,0,0,1,.236.315,1.544,1.544,0,0,0,.089.305h-.305a1.934,1.934,0,0,1-.108-.305c-.02-.128-.1-.187-.256-.187h-.138v.5Zm0-.709H84.9c.158-.01.3-.069.285-.2s-.089-.2-.276-.187a.318.318,0,0,0-.158.02v.364Z",
    transform: "translate(-21824.252 1579.166)",
    fill: "#6c8a32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27650",
    "data-name": "Trazado 27650",
    d: "M53.412,76.38c-1.083.443-2.855.492-2.992-.148-.1-.453.807-.226,1.811-.8,1.319-.738,1.713-1.132,2.087-.787.443.433.453,1.181-.9,1.742M61,71.36c-3.583,2.746-5.148,3.957-5.621,2.717-.266-.679.866-1.112,1.851-2.067,1.25-1.211,2.717-3.111,4.1-4.223,1.6-1.289,2.609-.935,2.953-.148.532,1.142-1.3,2.185-3.288,3.721",
    transform: "translate(-21823.732 1579.394)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChilis);
export default __webpack_public_path__ + "static/media/chilis.6bcfefafcd5c441f7a9be9aad5aaa058.svg";
export { ForwardRef as ReactComponent };